import { useTranslation } from "react-i18next";

const cfg: Record<string, { color: string; labelKey: string }> = {
  PREPARING: { color: "var(--color-warning)", labelKey: "status.preparing" },
  RUNNING:   { color: "var(--color-success)",  labelKey: "status.running" },
  COMPLETED: { color: "var(--color-text-dim)", labelKey: "status.completed" },
};

export default function StatusDot({ status }: { status: string }) {
  const { t } = useTranslation();
  const { color, labelKey } = cfg[status] ?? cfg.COMPLETED;
  const label = t(labelKey);
  return (
    <span style={{
      display: "inline-flex", alignItems: "center",
      padding: "3px 10px", borderRadius: 99,
      background: `color-mix(in srgb, ${color} 25%, var(--color-bg))`,
      border: `1px solid color-mix(in srgb, ${color} 45%, transparent)`,
      fontSize: "0.65rem", fontWeight: 700, textTransform: "uppercase" as const,
      letterSpacing: "0.08em", color, flexShrink: 0,
    }}>
      {label}
    </span>
  );
}
